var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVegan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15480_210719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22656 0.492981C7.3875 0.647669 6.56719 1.06017 6.10781 1.56173C5.61563 2.09611 5.26875 2.80861 5.15625 3.53048C5.07656 4.00392 5.12344 4.96954 5.24063 5.45236C5.29219 5.65392 5.34375 5.82736 5.35781 5.84142C5.36719 5.85548 5.475 5.73361 5.59219 5.56954C6.40781 4.43048 7.725 3.14611 9.00469 2.22736C9.49688 1.87579 9.64219 1.81954 9.75 1.94611C9.85313 2.07267 9.77344 2.17579 9.27656 2.52736C8.50781 3.07111 7.90781 3.58673 7.24219 4.27579C5.92969 5.62579 5.10469 6.84454 4.72969 7.99298C4.55156 8.54142 4.52344 8.58829 4.36875 8.56954C4.25625 8.55548 4.23281 8.50861 4.07344 7.93673C3.675 6.55392 2.82656 4.72579 2.00156 3.49298C1.61719 2.91642 1.05938 2.20392 0.989063 2.20392C0.9 2.20392 0.421875 2.71954 0.421875 2.81329C0.421875 2.85079 0.46875 2.93517 0.520313 3.00079C0.571875 3.06642 0.754688 3.32892 0.932813 3.58673C2.37656 5.71486 3.61875 8.83204 3.93281 11.1242C3.95625 11.3024 4.00313 11.4758 4.03594 11.5133C4.09219 11.5836 4.29844 11.6024 4.39688 11.5414C4.42969 11.518 4.52813 11.2274 4.61719 10.8899C5.10938 9.02423 5.83125 7.12579 6.22969 6.65704C6.34219 6.52111 6.37969 6.51173 6.82031 6.46954C8.42344 6.31954 9.4125 5.79923 9.8625 4.87111C9.95625 4.66954 10.1859 3.97579 10.3828 3.28673C10.7625 1.95079 10.9266 1.56642 11.325 1.03673C11.4656 0.849231 11.5688 0.680481 11.5547 0.666419C11.5453 0.652356 11.3156 0.600794 11.0531 0.553919C10.3922 0.427356 8.76094 0.394544 8.22656 0.492981Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15480_210719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegan);
export default __webpack_public_path__ + "static/media/vegan.9200cd01a61e39d7c953afdeb34893cd.svg";
export { ForwardRef as ReactComponent };